import { render, staticRenderFns } from "./DemoReplayPage.vue?vue&type=template&id=bd4f2622&scoped=true"
import script from "./DemoReplayPage.vue?vue&type=script&lang=js"
export * from "./DemoReplayPage.vue?vue&type=script&lang=js"
import style0 from "./DemoReplayPage.vue?vue&type=style&index=0&id=bd4f2622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4f2622",
  null
  
)

export default component.exports